









// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { AssetVersion } from "@/psychlab/types/assets";
import { useAssets } from "@/hooks/useAssets";
import * as StudyAPI from "@/services/api/studies";
// local
import { useVersionCache } from "../../ts/useVersionCache";

export default defineComponent({

	emits:[],
	props:{
		studyId:{
			type:String,
			required:true,
		},
	},
	components:{
	},
	setup(props){
		
		const count = ref(0);
		

		const init = async () => {
			try {
				count.value = await StudyAPI.countStudySessions(props.studyId);
			}
			catch(err){}
		};

		init();

		return {
			count,
		};
	}
});

